import { PartyState } from "../constants/commonenums";
import { PartyNoteDTO } from "./PartyModels";

export class SessionBookingDTO {
    BookingId: number;
    ActivityId: number;
    ClassType: number;
    FromDate: string;
    ToDate: string;
    Location: number[];
    LocationName: string[];
    StaffId: number[];
    BookingSize: number;
    MembershipDetail: string;
    GuestTypes: CoverType[];
    BookingTypes: BookingType[];
    Slots: any[];
    SessionGroupId: number;
    AvailabilityCriteria: number;
    propertyId: number;
    CartId: string;
    Notes: PartyNoteDTO[];
    SeatingAreaId: number;
    SeatingTypeId: number;
    LocalTime: string;
    isCommunalTable: boolean;
    TableIds: number [];
    FromWebsite: boolean;
    isBookingApiRequest: boolean;

    constructor(bookingId, activityId, classType, fromDate, toDate, location, locationName, staffId,
    bookingSize, membershipDetails, guestTypes, bookingTypes, slots, sessionGroupId, propertyId?,
    SeatingArea?, SeatingType?, LocalTime?, isCommunalTable?, TableIds?, FromWebsite?) {
        this.BookingId = bookingId;
        this.ActivityId = activityId;
        this.ClassType = classType;
        this.FromDate = fromDate;
        this.ToDate = toDate;
        this.Location = location;
        this.LocationName = locationName;
        this.StaffId = staffId;
        this.BookingSize = bookingSize;
        this.MembershipDetail = membershipDetails;
        this.GuestTypes = guestTypes;
        this.BookingTypes = bookingTypes;
        this.Slots = slots;
        this.SessionGroupId = sessionGroupId;
        this.propertyId = propertyId;
        this.SeatingAreaId = SeatingArea;
        this.SeatingTypeId = SeatingType;
        this.LocalTime = LocalTime;
        this.isCommunalTable = isCommunalTable;
        this.TableIds = TableIds;
        this.FromWebsite = FromWebsite;
    }
}

export class CoverType {
    CoverTypeId: number;
    Covers: number;
    Name: string;
}
export class BookingType {
    BookingTypeId: number;
    BookingTypes: number;
    Name: string;
}

export class ActivitySessionsDTO {
    public SessionGroupId: number;
    public ActivitySessionId: number;
    public SpecialMealId: number;
    public Dayofweek: number;
    public SessionName: string;
    public SessionDescription: string;
    public StartTime: Date;
    public EndTime: Date;
    public BookedSlots: number;
    public RatePlanId: number;
    public AllocationTypeId: number;
    public IsBooked: boolean;
    public SessionStaffMappings: SessionStaffMappingDTO[];
    public SessionLocationMappings: SessionLocationMappingDTO[];
    public BookedSessions: BookedSessionsDTO[];
}

export class SessionStaffMappingDTO {
    public Id: number;
    public ActivitySessionId: number;
    public ServerId: number;
}

export class SessionLocationMappingDTO {
    public Id: number;
    public ActivitySessionId: number;
    public StandaloneTableId: number;
}

export class BookedSessionsDTO {
    public Id: number;
    public PartyId: number;
    public ActivitySessionId: number;
    public BookedDate: Date;
    public BookingSize: number;
    public SessionState: PartyState;
    public RatePlanAmount: number;
}

export class ActivitySlotRequestDTO {
    ActivityId: number;
    AvailabilityCriteria: AvailabilityCriteria;
    StartDate: string;
    EndDate: string;
    PreferredLocationId: number[];
    PreferredStaffId: number[];
    BookingSize: number;
    ClassType: ClassType
}

export enum AvailabilityCriteria {
    None = 0,
    IncludeLocation = 1,
    IncludeInstructor = 2,
    IncludeLocationAndInstructor = 3,
}

export enum ClassType {
    Session = 0,
    Class = 1
}

export enum AvailabilityType {
    OpenToAll,
    OpenToSpecificMember,
    SoldOut,
    SelectionCriteriaNotMatched,
    Standby,
    Blocked,
    Cancelled
}

export class LockSessionRequestDTO {
    public Sessions: SessionDateDTO[];
    public ActivityId: number;
    public SessionGroupId: number;
    public StartDate: string;
    public lockIdToIgnore: number;
    public BookingSize: number;
    public ClassType: ClassType;
    public PropertyId?: number;
    public PartySize?: number;
    public TableIds?: number [];
    public SeatingAreaId?: number;
    public SeatingTypeId?: number;
    public LocalTime?: string;
}

export class SessionDateDTO {
    Date: string;
    SessionIds: number[];
}

export enum BookingBehavior {
    OpenBooking,
    ClassOrSession,
    PrivateLesson
}

export class ActivityRatePlanRequest {
    Slots: any[];
    ActivityId: number;
    GuestTypes: GuestType[];
    BookingTypes: BookingType[];
    TableIds: number[];
    Size: number;
    SessionSlot: SessionSlot;
    BookingBehavior: BookingBehavior;
    MemberType: string;
    IsMemberActive: boolean;
}

export enum BookingActivity {
    OpenBooking,
    ClassBooking,
    PrivateLesson
}

export enum LessonTypes {
    GroupLesson,
    PrivateLesson,
    SpecialMeal,
    OpenBooking
}


export class GuestType {
    CoverTypeId: number;
    covers: number;
}

export class SessionSlot {
    Sessions: Session[];
    SessionGroupId: any;
}

export class Session {
    Date: string;
    SessionIds: number[];
}